import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Login from "./components/Auth/Login"
import Register from "./components/Auth/Register"
import ProfileEdit from "./components/Profile/ProfileEdit";
import CenterSearch from "./components/Center/Search";
import ProtectedRoute from "./components/Utils/ProtectedRoute";

const routes = [
  { path: "/", element: <Home /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  {
    path: "/profile",
    element: <ProtectedRoute />, // 인증이 필요한 경로
    children: [{ path: "", element: <ProfileEdit /> }],
  },
  { path: "/search", element: <CenterSearch /> },
  { path: "/contact", element: <Contact /> },
];

export default routes;
